"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Panel;

var _immutable = require("immutable");

var _Constants = require("FileManagerLib/Constants");

var _ActionTypes = require("FileManagerLib/actions/ActionTypes");

var defaultState = (0, _immutable.Map)({
  selectedFolder: null,
  selectedFile: null,
  selectedStockFile: null,
  activePanel: _Constants.Panels.BROWSE,
  searchQuery: ''
});

function Panel() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      selectedFolder = action.selectedFolder,
      selectedFile = action.selectedFile,
      activePanel = action.activePanel,
      searchQuery = action.searchQuery;

  switch (type) {
    case _ActionTypes.SET_PANEL:
      return state.merge({
        selectedFolder: selectedFolder || null,
        selectedFile: null,
        selectedStockFile: null,
        searchQuery: searchQuery || '',
        activePanel: activePanel
      });

    case _ActionTypes.SEARCH:
      return state.merge({
        selectedFile: selectedFile,
        searchQuery: searchQuery
      });

    case _ActionTypes.SELECT_FILE:
      return state.set('selectedFile', selectedFile);

    case _ActionTypes.SELECT_STOCK_FILE:
      return state.set('selectedStockFile', selectedFile);

    default:
      return state;
  }
}

module.exports = exports.default;